import { MARK_LOOP_MS, MARK_START_OFFSET_MS } from './loaderKeyframes';

/**
 * One loading screen is shown by three different places during a cold boot — the auth
 * check, the route chunk's Suspense fallback, and the shell overlay — so the user sees a
 * sequence of separate LoadingLogo instances, not one long-lived one.
 *
 * A CSS animation restarts from its first frame whenever its element is created, so each
 * of those handoffs used to snap the mark back to assembled and burst it outward again.
 * This keeps the loop on a wall clock instead: every instance works out how far along the
 * shared timeline it is and offsets its animation to match, so a remount is invisible.
 */
const timeline = {
  epochMs: null as number | null,
};

export interface LoaderPhase {
  /** Negative animation-delay for the mark, in ms. */
  markDelayMs: number;
}

/**
 * Called once per LoadingLogo mount. Starts the shared clock on the first call.
 */
export const claimLoaderPhase = (): LoaderPhase => {
  const now = performance.now();
  if (timeline.epochMs === null) timeline.epochMs = now;

  // Offsetting the epoch by the skipped hold means the first instance resolves to exactly
  // -MARK_START_OFFSET_MS, i.e. poised on the explode.
  const elapsed = (now - timeline.epochMs) + MARK_START_OFFSET_MS;

  return { markDelayMs: -(elapsed % MARK_LOOP_MS) };
};

/** Tests only: the module-level clock would otherwise leak between cases. */
export const resetLoaderTimeline = () => {
  timeline.epochMs = null;
};
